<template>
  <v-app id="inspire">
    <v-app-bar
        app
        color="primary"
        dark
        dense
    >
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              icon
              @click="back"
              color="accent"
              v-bind="attrs"
              v-on="on"
              :hidden="$route.name === 'Buildings' || $route.name === 'Contacts'">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </template>
        <span>Zurück</span>
      </v-tooltip>
      <v-toolbar-title class="accent--text">{{ appTitle }}</v-toolbar-title>
      <v-spacer/>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              icon
              v-bind="attrs"
              v-on="on"
              @click="$router.push({name: 'EwonDebugView'})">
            <v-icon>mdi-router-wireless</v-icon>
          </v-btn>
        </template>
        <span>Inbetriebnahme Router</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              v-bind="attrs"
              v-on="on"
              :loading="excelLoading"
              icon
              @click="openDownloadDialog">
            <v-icon>mdi-file-excel</v-icon>
          </v-btn>
        </template>
        <span>Excelexport</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              v-bind="attrs"
              v-on="on"
              icon
              @click="$router.push({name: 'Buildings'})">
            <v-icon>
              mdi-domain
            </v-icon>
          </v-btn>
        </template>
        <span>Projektübersicht</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              v-bind="attrs"
              v-on="on"
              icon
              @click="$router.push({name: 'Contacts'})">
            <v-icon>
              mdi-account-multiple
            </v-icon>
          </v-btn>
        </template>
        <span>Kontaktübersicht</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              v-bind="attrs"
              v-on="on"
              icon
              @click="$router.push({name: 'Users'})">
            <v-icon>
              mdi-account-cog
            </v-icon>
          </v-btn>
        </template>
        <span>Benutzerübersicht</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              v-bind="attrs"
              v-on="on"
              icon>
            <language-list width="100px"></language-list>
          </v-btn>
        </template>
        <span>Sprache wählen</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              v-bind="attrs"
              v-on="on"
              icon
              @click="logout">
            <v-icon>mdi-logout</v-icon>
          </v-btn>
        </template>
        <span>Abmelden</span>
      </v-tooltip>
      <a
          hidden
          ref="excelall"
          :download="'Alle_BVH_Auswertung.xlsx'"
          :href="allExcelData">link</a>
    </v-app-bar>

    <v-main>
      <transition name="page" mode="out-in">
        <router-view/>
      </transition>
      <date-picker-dialog/>
    </v-main>
  </v-app>
</template>

<script>

import axios from 'axios'
import LanguageList from "./components/LanguageList";
import eventBus from "./plugins/EventBus"
import DatePickerDialog from "@/components/DatePickerDialog";

export default {
  data() {
    return {
      appTitle: 'WÖHR Connect',
      excelLoading: false,
      allExcelData: '',
      langs: ['de'],
      selectedLanguage: this.$i18n.locale,
      valueStart: '',
      valueEnd: '',
      datePickerDialog: false
    }
  },
  components: {
    LanguageList,
    DatePickerDialog
  },
  mounted: function () {
    this.initVuexData();
    eventBus.$on("downloadWithAxios", selectedInterval => {
      this.valueStart = selectedInterval[0].start
      this.valueEnd = selectedInterval[0].end
      this.downloadWithAxios()
    });
  },
  methods: {
    initVuexData: function () {
      this.$store.dispatch('loadBuildings');
      this.$store.dispatch('loadContacts');
      this.autoRefreshBuildingStates();
    },
    autoRefreshBuildingStates() {
      setTimeout(() => {
        setInterval(() => {
          this.$store.dispatch('loadStates')
        }, 60000)
      }, 60000)
    },
    back() {
      this.$router.back();
    },
    logout() {
      this.$keycloak.logoutFn();
    },
    openDownloadDialog() {
      eventBus.$emit('datePickerDialog', true)
    },
    downloadWithAxios() {
      this.excelLoading = true;
      axios({
        url: '/legacy-m2m/api/download/excel/?start=' + this.valueStart + '&end=' + this.valueEnd,
        method: 'GET',
        responseType: 'blob', // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Alle_BVH_Auswertung.xlsx');
        document.body.appendChild(link);
        link.click();
        this.excelLoading = false
      })
    }
  }
};
</script>


<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #fff8cc;
}

.page-enter-active, .page-leave-active {
  transition: opacity 150ms, transform 200ms;
}

.page-enter, .page-leave-to {
  opacity: 0;
}
</style>
